import {
  FIXED_ASSET_CATEGORIES,
  LIQUID_ASSET_CATEGORIES,
  PERSONAL_ITEM_CATEGORIES,
} from "../constants";

/**
 * Fallback asset_type derivation from a category, used only when neither
 * the dialog's tab context nor the edited asset provides one.
 */
export function deriveAssetType(category) {
  if (FIXED_ASSET_CATEGORIES.includes(category)) return "fixed";
  if (LIQUID_ASSET_CATEGORIES.includes(category)) return "liquid";
  if (PERSONAL_ITEM_CATEGORIES.includes(category)) return "personal";
  return null;
}